import React, { Component } from 'react';

class FieldWrapper extends Component {
  render() {
    let { errors, touched, status, id } = this.props;
    return (
      <div className="form-group">
        <label htmlFor={this.props.id} className="col-md-4 control-label">{this.props.fieldName}</label>
        <div className="col-md-8">
          {this.props.children}
        </div>
        <span className="col-md-4"> </span>
        <div className="col-md-8 errorMessage">
          {
            touched[id] && (errors[id] || (status && status[id])) && <div className="input-feedback">{errors[id] || (status && status[id])}</div>
          }
        </div>
      </div>
    )
  }
}

export default FieldWrapper;


// WEBPACK FOOTER //
// ./src/Components/Form/FieldWrapper.js